import React from 'react';
import { Link } from 'react-router-dom';
import { publicAssetPath } from '../utils/publicAssetPath';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex">
      <div className="m-auto max-w-xl w-full px-4">
        <div className="text-center space-y-10">
          <div className="space-y-4 flex flex-col items-center">
            {/* لوگو رو با نام logo.png در پوشه frontend/public قرار بدید */}
            <img src={publicAssetPath('/logo.png')} alt="لوگو پایتخت" className="w-24 h-24 object-contain mb-2" />
            <h1 className="text-3xl sm:text-4xl font-bold text-blue-700">
              مرکز تصویربرداری پایتخت
            </h1>
            <p className="text-lg text-gray-600 mt-2">
              لطفاً یکی از گزینه‌های زیر را انتخاب کنید
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap">
            <Link to="/booking" className="home-action-button">
              نوبت‌دهی
            </Link>
            <Link to="/search" className="home-action-button">
              جستجوی نوبت
            </Link>
            <Link to="/complaints" className="home-action-button">
              انتقادات و پیشنهادات
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
